import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(pattern) {
  const req = axiosCommon.getAxiosParamsAuth(`/patterns/${pattern.id}`, 'put', pattern)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/patterns/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(pattern) {
  const req = axiosCommon.getAxiosParamsAuth('/patterns', 'post', pattern)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/patterns?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
}


